import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';

type HeaderSectionProps = {
  title: string;
  subTitle: string;
};
export default function HeaderSection({ title, subTitle }: HeaderSectionProps) {
  return (
    <Container className='flex flex-col'>
      <Text
        className='text-[17px] font-bold tracking-tighter text-[#424244]'
        type={TEXT_TYPE.SPAN}
      >
        {title}
      </Text>
      <Text
        className='font-light text-[13px] tracking-tighter text-[#878F9B]'
        type={TEXT_TYPE.SPAN}
      >
        {subTitle}
      </Text>
    </Container>
  );
}
